import './apps.css'
import { Route, Routes } from "react-router-dom";
import ContactManager from './ContactManager/ContactManager';

function Apps() {
    return (
        <div id="appsModule">
            <Routes>
                <Route path={'/contactManager'} element={<ContactManager />} />
            </Routes >
        </div >
    )
}

export default Apps; 